// @flow

import type {
  ActionCreator,
} from 'fc-flow-types/redux'

// Utils
import createAction from 'fc-utils/createAction'

// Action Types
import {
  RECEIVE_AUTHENTICATED_USER,
} from './constants'

export const receiveAuthenticatedUser: ActionCreator<number> = createAction(RECEIVE_AUTHENTICATED_USER)
